// Detect if we're in production (Hostinger) or development/prototype (Netlify/localhost)
// Production uses the PHP API, everything else falls back to localStorage.

const productionDomains = [
    'knitster-ldn.com',
    'www.knitster-ldn.com',
    // Add any other production domains
];

export const isProduction = () => {
    const hostname = window.location.hostname;
    return productionDomains.some(domain => hostname.includes(domain));
};

export const getStorageMode = () => (isProduction() ? 'api' : 'local');

export const API_BASE = '/api';
